// extracted by mini-css-extract-plugin
module.exports = {"rowHeight":"6","checkBoxColumnWidth":"6","container":"FactorinGrid_container__3T1fk"};